import DpBillsReportUseCase from "@domains/useCases/Reports/DpBills/DpBillReport";
export default (repositories) => {
    return {
        dpBillReport: new DpBillsReportUseCase(repositories.dpBillReport),
    };
};
